import { render } from "./user-account.vue?vue&type=template&id=00c5cc80&ts=true"
import script from "./user-account.vue?vue&type=script&lang=ts"
export * from "./user-account.vue?vue&type=script&lang=ts"

import "./user-account.vue?vue&type=style&index=0&id=00c5cc80&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__